import { Directive, ElementRef, Input, HostListener, NgModule } from '@angular/core';
import '@angular/forms';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxScrollToFirstInvalidDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
    }
    /**
     * @param {?} element
     * @return {?}
     */
    static scrollToElement(element) {
        if (element) {
            /** @type {?} */
            const distance = window.pageYOffset - Math.abs(element.getBoundingClientRect().y);
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: element.getBoundingClientRect().top + window.scrollY - 150
            });
            setTimeout((/**
             * @return {?}
             */
            () => {
                element.focus();
                element.blur(); // Trigger error messages
                element.focus();
            }), distance);
        }
    }
    /**
     * @param {?} formGroup
     * @return {?}
     */
    static markFormGroupTouched(formGroup) {
        ((/** @type {?} */ (Object))).values(formGroup.controls).forEach((/**
         * @param {?} control
         * @return {?}
         */
        control => {
            control.markAsTouched();
            if (control.controls) {
                NgxScrollToFirstInvalidDirective.markFormGroupTouched(control);
            }
        }));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onSubmit(event) {
        event.preventDefault();
        if (!this.formGroup.valid) {
            NgxScrollToFirstInvalidDirective.markFormGroupTouched(this.formGroup);
            /** @type {?} */
            const formControlInvalid = this.el.nativeElement.querySelector('.ng-invalid');
            if (formControlInvalid) {
                return NgxScrollToFirstInvalidDirective.scrollToElement(formControlInvalid);
            }
            else {
                // The first element is the global form and here we are looking for the first nested form
                /** @type {?} */
                const formGroupInvalid = this.el.nativeElement.querySelectorAll('form .ng-invalid');
                if (formGroupInvalid && formGroupInvalid.length) {
                    return NgxScrollToFirstInvalidDirective.scrollToElement(formGroupInvalid[0]);
                }
            }
            return NgxScrollToFirstInvalidDirective.scrollToElement(this.el.nativeElement);
        }
    }
}
NgxScrollToFirstInvalidDirective.ɵfac = function NgxScrollToFirstInvalidDirective_Factory(t) { return new (t || NgxScrollToFirstInvalidDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxScrollToFirstInvalidDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxScrollToFirstInvalidDirective, selectors: [["", "ngxScrollToFirstInvalid", ""]], hostBindings: function NgxScrollToFirstInvalidDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("submit", function NgxScrollToFirstInvalidDirective_submit_HostBindingHandler($event) { return ctx.onSubmit($event); });
    } }, inputs: { formGroup: "formGroup" } });
/** @nocollapse */
NgxScrollToFirstInvalidDirective.ctorParameters = () => [
    { type: ElementRef }
];
NgxScrollToFirstInvalidDirective.propDecorators = {
    formGroup: [{ type: Input }],
    onSubmit: [{ type: HostListener, args: ['submit', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxScrollToFirstInvalidDirective, [{
        type: Directive,
        args: [{ selector: '[ngxScrollToFirstInvalid]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { 
    /**
     * @param {?} event
     * @return {?}
     */
    onSubmit: [{
            type: HostListener,
            args: ['submit', ['$event']]
        }], formGroup: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxScrollToFirstInvalidModule {
}
NgxScrollToFirstInvalidModule.ɵfac = function NgxScrollToFirstInvalidModule_Factory(t) { return new (t || NgxScrollToFirstInvalidModule)(); };
NgxScrollToFirstInvalidModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxScrollToFirstInvalidModule });
NgxScrollToFirstInvalidModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxScrollToFirstInvalidModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [NgxScrollToFirstInvalidDirective],
                exports: [NgxScrollToFirstInvalidDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxScrollToFirstInvalidModule, { declarations: [NgxScrollToFirstInvalidDirective], exports: [NgxScrollToFirstInvalidDirective] }); })();

export { NgxScrollToFirstInvalidModule, NgxScrollToFirstInvalidDirective as ɵa };

//# sourceMappingURL=ismaestro-ngx-scroll-to-first-invalid.js.map